import MapPage from "Views/MapPage/MapPage";
import HomePage from "Views/HomePage/HomePage";

const publicRoutes = [
  { path: "/", name: "Karta", component: MapPage },
  //{ path: "/", name: "Naslovna", component: HomePage }
];

export default publicRoutes